import { render, staticRenderFns } from "./LoginSecurity.vue?vue&type=template&id=46b5fae5&scoped=true&"
import script from "./LoginSecurity.vue?vue&type=script&lang=js&"
export * from "./LoginSecurity.vue?vue&type=script&lang=js&"
import style0 from "./LoginSecurity.vue?vue&type=style&index=0&id=46b5fae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b5fae5",
  null
  
)

export default component.exports